<page-header [section]="'general-reporting'">
  <page-title>General Reporting</page-title>
  <page-blurb
    >Manage and check status of PSK Category, Gateways and Sensors.</page-blurb
  >
</page-header>

<div class="row">
  <div class="col-12 overlayParent">
    <div class="card">
      <div class="overlay" *ngIf="weatherRanges.loading == true">
        <widget-spinner></widget-spinner>
      </div>
      <div>
        <div class="card-header">
          <div class="row">
            <div class="col-12"><h6>Weather service PSK Range lookup</h6></div>
            <div class="col-2" style="min-width: 135px">
              <select [(ngModel)]="categorySelector" class="form-control">
                <option value="1">Category 1</option>
                <option value="2">Category 2</option>
                <option value="3">Category 3</option>
              </select>
            </div>
            <div class="col">
              <button
                class="btn-sm btn-primary"
                style="margin-top: 0px"
                (click)="getWeatherLoaded()"
              >
                Get Ranges in Category
              </button>
            </div>
          </div>
        </div>
        <div class="card-block" *ngIf="weatherRanges.categories">
          <div
            class="col-12"
            style="margin: 5px"
            *ngIf="weatherRanges.categories['1'].length > 0"
          >
            Category 1: <br />
            <div
              style="width: 100%"
              *ngFor="let r of weatherRanges.categories['1']"
            >
              {{ r }}
            </div>
          </div>
          <div
            class="col-12"
            style="margin: 5px"
            *ngIf="weatherRanges.categories['2'].length > 0"
          >
            Category 2: <br />
            <div
              style="width: 100%"
              *ngFor="let r of weatherRanges.categories['2']"
            >
              {{ r }}
            </div>
          </div>
          <div
            class="col-12"
            style="margin: 5px"
            *ngIf="weatherRanges.categories['3'].length > 0"
          >
            Category 3: <br />
            <div
              style="width: 100%"
              *ngFor="let r of weatherRanges.categories['3']"
            >
              {{ r }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 overlayParent">
    <div class="card">
      <div class="overlay" *ngIf="report.data.gateways == -1">
        <widget-spinner></widget-spinner>
      </div>
      <div>
        <div class="card-header">
          Gateways
          <button
            class="btn-sm btn-primary float-right"
            (click)="report.getGatewaysTally()"
          >
            Get Tally
          </button>
        </div>
        <div class="card-block">
          <div *ngIf="report.data.gateways && report.data.gateways != -1">
            <pre>{{ report.data.gateways | json }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 overlayParent">
    <div class="card">
      <div class="overlay" *ngIf="report.data.sensors == -1">
        <widget-spinner></widget-spinner>
      </div>
      <div>
        <div class="card-header">
          Sensors
          <button
            class="btn-sm btn-primary float-right"
            (click)="report.getSensorsTally()"
          >
            Get Tally
          </button>
        </div>
        <div class="card-block">
          <div *ngIf="report.data.sensors && report.data.sensors != -1">
            <pre>{{ report.data.sensors | json }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="card-header">
        View status checker
        <button (click)="checkView($event)" class="btn btn-info float-right">
          Get last check result
        </button>
      </div>
      <div class="card p-4 shadow-sm">
        <div *ngIf="!(alarmActive === -1)">
          <div class="d-flex justify-content-end mb-3">
            <button
              *ngIf="!alarmActive"
              class="btn btn-success"
              (click)="changeActivation(true)"
            >
              Activate Alarm
            </button>
            <button
              *ngIf="alarmActive"
              class="btn btn-danger"
              (click)="changeActivation(false)"
            >
              Deactivate Alarm
            </button>
          </div>
        </div>

        <div *ngIf="checkDate" class="mb-3">
          <h5>Status Check</h5>
          <p class="mb-1">
            Time:
            <strong>{{ checkDate | date : "MM/dd/yyyy @ h:mm:ssa" }}</strong>
          </p>
          <p>
            Status: <strong>{{ checkStatus }}</strong>
          </p>
        </div>

        <div *ngIf="statusObtained">
          <div class="mb-4">
            <h5>Alarm Status</h5>
            <p class="mb-1">
              <strong>{{
                checkVars.active == 0 ? "Deactivated" : "Active"
              }}</strong>
            </p>
            <p class="mb-1">
              Time before device marked as not seen:
              <strong>{{ checkVars.notSeenSeconds }}</strong> seconds
            </p>
            <p class="mb-1">
              Minimum time between notification emails:
              <strong>{{ checkVars.emailGap / 60 }}</strong> minutes
            </p>
            <p class="mb-1">
              Max time to wait for device status before timeout:
              <strong>{{ checkVars.deviceCallTimeout }}</strong> seconds
            </p>
          </div>

          <div class="mb-4">
            <h5>Modify Alarm Values</h5>
            <div class="form-row align-items-center">
              <div class="col-auto">
                <label class="sr-only">Type</label>
                <select [(ngModel)]="alarmType" class="form-control">
                  <option value="2">Not Seen Seconds</option>
                  <option value="3">Email Minimum Time Seconds</option>
                  <option value="4">Device Status Timeout Seconds</option>
                </select>
              </div>
              <div class="col-auto">
                <input
                  type="number"
                  [(ngModel)]="alarmVal"
                  class="form-control"
                  placeholder="Seconds"
                />
              </div>
              <div class="col-auto">
                <button (click)="updateView(1, $event)" class="btn btn-primary">
                  Set Value
                </button>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5>Monitored Devices</h5>
            <ul class="list-group">
              <li
                *ngFor="let id of checkVars.deviceIds"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ id.val }}
                <button
                  *ngIf="deleteToggle"
                  class="btn btn-sm btn-outline-danger"
                  (click)="delete($event, id.key)"
                >
                  Delete
                </button>
              </li>
            </ul>
          </div>

          <div class="mb-4">
            <h5>Notification Emails</h5>
            <ul class="list-group">
              <li
                *ngFor="let email of checkVars.emails"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ email.val }}
                <button
                  *ngIf="deleteToggle"
                  class="btn btn-sm btn-outline-danger"
                  (click)="delete($event, email.key)"
                >
                  Delete
                </button>
              </li>
            </ul>
          </div>

          <div class="mb-2">
            <h5>Add Devices or Emails</h5>
            <div class="form-row align-items-center">
              <div class="col-auto">
                <select [(ngModel)]="alarmType2" class="form-control">
                  <option value="5">Devices</option>
                  <option value="6">Emails</option>
                </select>
              </div>
              <div class="col-auto">
                <input
                  type="text"
                  [(ngModel)]="alarmVal2"
                  class="form-control"
                  placeholder="Id / Email"
                />
              </div>
              <div class="col-auto">
                <button (click)="updateView(2, $event)" class="btn btn-primary">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer" *ngIf="checkDate">
        <button
          class="btn btn-warning floatRight"
          (click)="deleteToggle = !deleteToggle"
        >
          Toggle Delete Buttons
        </button>
      </div>
    </div>
  </div>
</div>
